import React, { useContext } from 'react';
import { Flex } from 'antd';

import ButtonDropdownFilter from '@totem/components/ui_components/filters/dropdownFilter/ButtonDropDownFilter';
import FiltersChipsContainer from '@totem/components/ui_components/filters/FilterChipsContainer';
import FiltersBody from '@totem/components/ui_components/filters/FiltersBody';
import FiltersContainer from '@totem/components/ui_components/filters/FiltersContainer';
import FilterTitleClean from '@totem/components/ui_components/filters/FilterTitleClean';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import { isNotNull } from '@totem/utilities/common';

const styles = {
  dropdown: {
    marginRight: '2rem',
  },
  rangeSelector: {
    marginRight: '2rem',
  },
  picker: {
    width: '15rem',
    marginRight: '15px',
    marginLeft: '15px',
  },
  pickerButton: {
    marginRight: '15px',
  },
  pickerButtonText: {
    fontWeight: 700,
  },
};

type Props = {
  keys: string[];
  extra: React.ReactNode;
  showFilterChips: boolean;
};

const DropDownFilters = ({ keys, extra, showFilterChips = true }: Props) => {
  const { getFilterOptions, getFilterField, getFilterValues, handleFilter } =
    useContext(InputContext);

  return (
    <FiltersContainer>
      <Flex justify={'space-between'} align={'center'}>
        <FiltersBody>
          {isNotNull(keys) &&
            keys.map((key) => {
              const filterField = getFilterField(key);

              return (
                <ButtonDropdownFilter
                  key={key}
                  label={isNotNull(filterField) ? filterField.label : key}
                  options={getFilterOptions(key)}
                  value={getFilterValues(key)}
                  onChange={(update) => handleFilter(key, update)}
                  style={styles.dropdown}
                />
              );
            })}
        </FiltersBody>
        <FilterTitleClean>{extra}</FilterTitleClean>
      </Flex>
      {showFilterChips && (
        <div style={{ marginTop: '.25rem' }}>
          <FiltersChipsContainer>
            <FilterChips />
          </FiltersChipsContainer>
        </div>
      )}
    </FiltersContainer>
  );
};

export default DropDownFilters;
